module.exports = __webpack_public_path__ + "static/media/tstm-emilson-cribari.955bdff2.webp";